import React, { useEffect, useState } from 'react';
import { Card, Switch, Typography, message, Row, Col } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { getEmergencyAccessStatus, toggleEmergencyAccess } from '../../services/settingsService';

const { Title, Text } = Typography;

const SettingsPage = () => {
  const [isEmergencyEnabled, setIsEmergencyEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    try {
      const res = await getEmergencyAccessStatus();
      setIsEmergencyEnabled(res.data.enabled);
    } catch (error) {
      // message.error("Impossible de charger l'état du mode urgence");
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (checked) => {
    setLoading(true);
    try {
      await toggleEmergencyAccess(checked);
      setIsEmergencyEnabled(checked);
      if (checked) {
        message.warning("Mode Urgence ACTIVÉ : Les délégués peuvent maintenant se connecter au Web.");
      } else {
        message.success("Mode Urgence DÉSACTIVÉ.");
      }
    } catch (error) {
      message.error("Erreur lors du changement d'état.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card bordered={false} className="criclebox tablespace mb-24" title="Paramètres Système">
            <div style={{ padding: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', borderBottom: '1px solid #f0f0f0', paddingBottom: '16px' }}>
                <div>
                  <Title level={5} style={{ margin: 0 }}>Accès Web de Secours (Délégués)</Title>
                  <Text type="secondary">
                    Autorise les délégués à se connecter à ce site web pour saisir des rapports en cas de panne de l'application mobile.
                  </Text>
                </div>
                <Switch 
                  checked={isEmergencyEnabled} 
                  onChange={handleToggle} 
                  loading={loading}
                  checkedChildren="ACTIVÉ" 
                  unCheckedChildren="DÉSACTIVÉ"
                  style={{ backgroundColor: isEmergencyEnabled ? '#faad14' : undefined }} // Orange pour alerte
                />
              </div>
              
              {isEmergencyEnabled && (
                <div style={{ backgroundColor: '#fffbe6', border: '1px solid #ffe58f', padding: '10px', borderRadius: '4px', display: 'flex', alignItems: 'center' }}>
                  <WarningOutlined style={{ color: '#faad14', fontSize: '20px', marginRight: '10px' }} />
                  <Text type="warning" strong>
                    Attention : Le mode urgence est actif. Les délégués ont accès à l'interface web simplifiée. 
                    N'oubliez pas de le désactiver une fois le problème mobile résolu.
                  </Text>
                </div>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SettingsPage;